module.exports = __webpack_public_path__ + "static/media/clouds-image.11145b9e.png";